<div class="flex flex-col gap-2" [formGroup]="form">
  @if (label()) {
    <label class="truncate" [ngClass]="smallLabel() ? 'text-sm' : ''" [for]="id()">
      {{ label() | transloco }}
      @if (isRequired()) {
        <span class="text-red" [ngClass]="smallLabel() ? 'text-sm' : ''">*</span>
      }
    </label>
  }

  <div [ngClass]="{'p-inputgroup w-full': !!icon()}">
    @if (icon()) {
      <span class="p-inputgroup-addon">
        <i [class]="icon()"></i>
      </span>
    }

    @if (isReadOnly()) {
      <input
        pInputText
        [value]="formattedReadOnlyValue()"
        [disabled]="true"
        class="w-full"
        [ngClass]="[icon() ? 'readOnlyWithIcon' : 'readOnly', alignRight() ? 'text-right' : '']"
      />
    } @else {
      <p-inputNumber
        [id]="id()"
        [attr.data-testid]="id() + '-input'"
        [formControlName]="fieldName()"
        [min]="finalMin()"
        [max]="finalMax()"
        [showButtons]="showButtons()"
        [step]="step()"
        [locale]="effectiveLocale()"
        [mode]="mode() === 'decimal' ? 'decimal' : undefined"
        [minFractionDigits]="mode() === 'decimal' ? minFractionDigits() : undefined"
        [maxFractionDigits]="mode() === 'decimal' ? maxFractionDigits() : undefined"
        [inputStyleClass]="alignRight() ? 'text-right' : ''"
        [placeholder]="placeholder() || ''"
        [ngClass]="{'p-invalid': form.get(fieldName())?.invalid && form.get(fieldName())?.touched}"
        fluid="true"
      >
      </p-inputNumber>
    }
  </div>
</div>
